import { Grid, Skeleton } from "@mui/material";

const SkeletonPaymentForm = () => {
  return (
    <Grid item xs={12} sx={{ mt: 3 }}>
      <Skeleton
        animation="wave"
        sx={{ maxWidth: 500, minHeight: 500, mt: { xs: -16, md: 0 } }}
      />
    </Grid>
  );
};

export default SkeletonPaymentForm;
